export function responseToMinimalHttpError(err) {
  var _err$_errorHandlerSta;
  const data = (_err$_errorHandlerSta = err._errorHandlerState) == null ? void 0 : _err$_errorHandlerSta.responseData;
  return {
    response: {
      data,
      status: err.status
    },
    requestId: err.headers.get('X-Wix-Request-Id')
  };
}
//# sourceMappingURL=responseErrorDecoders.js.map